"use client";

import { c as _c } from "react/compiler-runtime";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardHeader } from "@/components/ui/card";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MonthYearSelector } from "@/components/common/month-year-selector";
import { CalendarDays, SlidersHorizontal, X } from "lucide-react";
import useConstantValueList from "@/hooks/use-constant-value-list";
import { ButtonGroup } from "../ui/button-group";
import { Button } from "../ui/button";
import { RenderIf } from "./render-if";
export type EventFiltersType = {
  modeOfTraining: string;
  date: string;
};
type Props = {
  filters: EventFiltersType;
  onChange: React.Dispatch<React.SetStateAction<EventFiltersType>>;
};
export const EventFilters = t0 => {
  const $ = _c(44);
  const {
    filters,
    onChange
  } = t0;
  const {
    data: modeOfTrainings
  } = useConstantValueList("MODE_OF_TRAINING");
  let t1;
  if ($[0] !== onChange) {
    t1 = value => {
      onChange(prev => ({
        ...prev,
        modeOfTraining: value
      }));
    };
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleModeOfTraining = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = value_0 => {
      onChange(prev_0 => ({
        ...prev_0,
        date: value_0
      }));
    };
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleDateChange = t2;
  let t3;
  if ($[4] !== onChange) {
    t3 = () => {
      onChange({
        date: "",
        modeOfTraining: ""
      });
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClearFilters = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      label: "All trainings",
      value: ""
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== modeOfTrainings) {
    t5 = [t4, ...modeOfTrainings?.filter(_temp)];
    $[7] = modeOfTrainings;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const filteredModeOftrainings = t5;
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-muted-foreground flex items-center gap-1.5 text-[10px] font-bold tracking-wider uppercase"><SlidersHorizontal size={12} /><span>Training Mode</span></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== filteredModeOftrainings) {
    t7 = <TabsList className="hidden md:block">{filteredModeOftrainings.map(_temp2)}</TabsList>;
    $[10] = filteredModeOftrainings;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleModeOfTraining) {
    t8 = value_1 => handleModeOfTraining(value_1 as string);
    $[12] = handleModeOfTraining;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SelectTrigger className="w-full max-w-48" aria-label="Mode of Training"><SelectValue /></SelectTrigger>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SelectLabel>Mode of training</SelectLabel>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== filteredModeOftrainings) {
    t11 = <SelectContent alignItemWithTrigger={false} align="start"><SelectGroup>{t10}{filteredModeOftrainings.map(_temp3)}</SelectGroup></SelectContent>;
    $[16] = filteredModeOftrainings;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== filteredModeOftrainings || $[19] !== filters.modeOfTraining || $[20] !== t11 || $[21] !== t8) {
    t12 = <div className="md:hidden"><Select items={filteredModeOftrainings} defaultValue={filters.modeOfTraining} onValueChange={t8} value={filters.modeOfTraining}>{t9}{t11}</Select></div>;
    $[18] = filteredModeOftrainings;
    $[19] = filters.modeOfTraining;
    $[20] = t11;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== filters.modeOfTraining || $[24] !== handleModeOfTraining || $[25] !== t12 || $[26] !== t7) {
    t13 = <div className="flex flex-col gap-2">{t6}<Tabs defaultValue={filters.modeOfTraining} onValueChange={handleModeOfTraining} value={filters.modeOfTraining}>{t7}{t12}</Tabs></div>;
    $[23] = filters.modeOfTraining;
    $[24] = handleModeOfTraining;
    $[25] = t12;
    $[26] = t7;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="text-muted-foreground flex items-center gap-1.5 text-[10px] font-bold tracking-wider uppercase"><CalendarDays size={12} /><span>Starting Month</span></div>;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== filters.date || $[30] !== handleDateChange) {
    t15 = <MonthYearSelector value={filters.date} onChange={handleDateChange} />;
    $[29] = filters.date;
    $[30] = handleDateChange;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  const t16 = filters?.date !== "" || filters?.modeOfTraining !== "";
  let t17;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <X />;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== handleClearFilters) {
    t18 = <ButtonGroup><Button variant="outline" onClick={handleClearFilters}>{t17}Clear</Button></ButtonGroup>;
    $[33] = handleClearFilters;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t16 || $[36] !== t18) {
    t19 = <RenderIf condition={t16}>{t18}</RenderIf>;
    $[35] = t16;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t15 || $[39] !== t19) {
    t20 = <div className="flex flex-col gap-2 md:items-end">{t14}<ButtonGroup>{t15}{t19}</ButtonGroup></div>;
    $[38] = t15;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t13 || $[42] !== t20) {
    t21 = <Card className="mb-4"><CardHeader className="flex flex-wrap items-center justify-between gap-3">{t13}{t20}</CardHeader></Card>;
    $[41] = t13;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};
function _temp(item) {
  return item.value !== "251";
}
function _temp2(item_0) {
  return <TabsTrigger key={item_0.value} value={item_0.value}>{item_0.label}</TabsTrigger>;
}
function _temp3(item_1) {
  return <SelectItem key={item_1.value} value={item_1.value}>{item_1.label}</SelectItem>;
}